export const appName = 'PixiePoints';
